import { useEffect, useState } from "react";
import { Box, Divider, Skeleton, Tab, Tabs, Typography } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid';
import { useParams, useSearchParams } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { UBHourlyFilter } from "./UBHourlyFilter";
import moment from "moment";
import { TabPanel } from "../../components/TabPanel";
import { UBItem } from "./UBItem";
import { shortenFloat, shortenNumber } from "../../utils/number";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

const columns = [
    { field: 'category_label', headerName: 'Category', width: 300, align: "left"},
    { field: 'count_00', headerName: '12am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_01', headerName: '1am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_02', headerName: '2am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_03', headerName: '3am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_04', headerName: '4am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_05', headerName: '5am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_06', headerName: '6am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_07', headerName: '7am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_08', headerName: '8am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_09', headerName: '9am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_10', headerName: '10am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_11', headerName: '11am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_12', headerName: '12pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_13', headerName: '1pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_14', headerName: '2pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_15', headerName: '3pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_16', headerName: '4pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_17', headerName: '5pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_18', headerName: '6pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_19', headerName: '7pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_20', headerName: '8pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_21', headerName: '9pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_22', headerName: '10pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)},
    { field: 'count_23', headerName: '11pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => shortenNumber(data.value)}
];

const eventColumns = [
    { field: 'event_label', headerName: 'Hour', width: 300, align: "left"},
    { field: 'count_00', headerName: '12am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_01', headerName: '1am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_02', headerName: '2am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_03', headerName: '3am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_04', headerName: '4am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_05', headerName: '5am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_06', headerName: '6am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_07', headerName: '7am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_08', headerName: '8am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_09', headerName: '9am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_10', headerName: '10am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_11', headerName: '11am', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_12', headerName: '12pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_13', headerName: '1pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_14', headerName: '2pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_15', headerName: '3pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_16', headerName: '4pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_17', headerName: '5pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_18', headerName: '6pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_19', headerName: '7pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_20', headerName: '8pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_21', headerName: '9pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_22', headerName: '10pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)},
    { field: 'count_23', headerName: '11pm', width: 100, align: "left", headerAlign: "left", sortable: false, valueGetter: (data) => data?.row?.event_name?.includes("rate") ? `${shortenFloat(data.value)}%` : shortenNumber(data.value)}
];

const UBEnrollmentSkeleton = () => {
    return (
        <><Skeleton /><Skeleton /><Skeleton /></>
    );
};

export const UBEnrollment = () => {
    const { dashboard: pDashboard } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const [date, setDate] = useState(moment(searchParams.get("date") ?? new Date()));
    const [dateFormatted, setDateFormatted] = useState({
        date: date.format("YYYY-MM-DD"),
    });

    const { status: enrollmentStatus, data: enrollmentData } = useFetchData({
        endpoint: `unionbank/${pDashboard}/24hours/enrollment`,
        params: dateFormatted,
        defaultData: []
    });

    const { status: enrollmentCumulativeStatus, data: enrollmentCumulativeData } = useFetchData({
        endpoint: `unionbank/${pDashboard}/24hours/enrollment/cumulative`,
        params: dateFormatted,
        defaultData: []
    });

    useEffect(() => {
        setDateFormatted({
            date: date.format("YYYY-MM-DD"),
        })
    }, [date]);

    useEffect(() => {
        searchParams.set("date", date);
        setSearchParams(searchParams);
    }, [date, searchParams, setSearchParams]);

    return (
        <Box
            container
            minHeight="95vh"
            height="100%"
            sx={{
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 1,
                p: 1,
            }}
        >
            <Box sx={{ gridRow: { xs: "1", sm: "1", md: "1", lg: "1" }, gridColumn: "span 2", position: "sticky" }}>
                <UBHourlyFilter value={date} onChange={setDate} />
            </Box>

            <Box sx={{ gridRow: { xs: "2", sm: "2", md: "2", lg: "2" }, gridColumn: "span 2", position: "sticky" }}>
                <UBItem>
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        py={1}
                        align="left"
                    >
                        Enrollment by Hour
                    </Typography>
                
                    {enrollmentCumulativeStatus === "loading" ? <UBEnrollmentSkeleton /> : 
                        <>
                            <DataGrid
                                rows={[
                                    { id: 1, ...enrollmentData?.find(event => event?.category_name === "total" && event?.event_name === "adjusted_account_creation")},
                                    { id: 2, ...enrollmentData?.find(event => event?.category_name === "fte_cta_total" && event?.event_name === "success_rate")},
                                    { id: 3, ...enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "adjusted_account_creation")},
                                    { id: 4, ...enrollmentData?.find(event => event?.category_name === "summary" && event?.event_name === "technical_error_count")}
                                ]}
                                columns={eventColumns}
                                hideFooter
                                autoHeight
                            />

                            <Grid container spacing={2} py={2} px={1}>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="h6">Category Definitions:</Typography>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography component="div" align="right" variant="caption">*Count increased due to inclusion of General category</Typography>
                                </Grid>
                                <Grid sm={12} md={12}>
                                    <Typography align="left" variant="body1">Hourly is the number of Web + Mobile Union Bank specific enrollments</Typography>
                                </Grid>
                                <Grid sm={12} md={12}>
                                    <Typography align="left" variant="body1">Cumulative is the number of enrollments from 3pm ct 5/28 to present</Typography>
                                </Grid>
                                <Grid sm={12} md={12}>
                                    <Typography align="left" variant="body1">Success rate is calculated by successful attempts vs total attempts</Typography>
                                </Grid>
                                <Grid sm={12} md={12}>
                                    <Typography align="left" variant="body1">Error rate is counted as technical mainframe errors</Typography>
                                </Grid>
                            </Grid>
                        </>
                    }
                </UBItem>
            </Box>

            <Box sx={{ gridRow: { xs: "3", sm: "3", md: "3", lg: "3" }, gridColumn: "1"}}>
                <UBItem>
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        align="left"
                    >
                        Totals
                    </Typography>

                    <Divider/>

                    {enrollmentCumulativeStatus === "loading" ? <UBEnrollmentSkeleton /> :
                        <>
                            <Grid container spacing={2} py={2} px={1}>
                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="h6">Cumulative Enrolled</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                    <Typography align="right">{shortenNumber(enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "adjusted_account_creation")?.["count_22"])}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="h6">{"Mortgage Enrolled (pre-conversion weekend)*"}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                    <Typography align="right">{"13,000"}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="h6">{"Customer Combined*"}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                    <Typography align="right">{"72,000"}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="h6">Total Enrolled</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                    <Typography align="right">{shortenNumber(parseInt(enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "adjusted_account_creation")?.["count_22"]) + 13000 + 72000)}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={6} md={6}>
                                    <Typography align="left" variant="caption">*These are approximations</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>
                            </Grid>
                        </>
                    }
                </UBItem>
            </Box>

            <Box sx={{ gridRow: { xs: "3", sm: "3", md: "3", lg: "3" }, gridColumn: "2"}}>
                <UBItem>
                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        align="left"
                    >
                        Union Bank Enrolled Base
                    </Typography>

                    <Divider/>

                    {enrollmentCumulativeStatus === "loading" ? <UBEnrollmentSkeleton /> :
                        <>
                            <Grid container spacing={2} py={2} px={1}>
                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center" variant="h6">30 Day Active</Typography>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center" variant="h6">Total Enrolled</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center">{"493,000"}</Typography>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center">{"744,000"}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center">{`${shortenFloat(((parseInt(enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "adjusted_account_creation")?.["count_22"]) + 12000 + 72000) / 493000) * 100)}%`}</Typography>
                                </Grid>
                                <Grid sm={4} md={4}>
                                    <Typography align="center">{`${shortenFloat(((parseInt(enrollmentData?.find(event => event?.category_name === "cumulative" && event?.event_name === "adjusted_account_creation")?.["count_22"]) + 12000 + 72000) / 744000) * 100)}%`}</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>

                                <Grid sm={2} md={2}>
                                </Grid>
                                <Grid sm={8} md={8}>
                                    <Typography component="div" align="center" variant="caption">Note: This is for benchmarking purposes only and is not completely accurate</Typography>
                                </Grid>
                                <Grid sm={2} md={2}>
                                </Grid>
                            </Grid>
                        </>
                    }
                </UBItem>
            </Box>
        </Box>
    );
}